import React, { useEffect, useState } from 'react'
import styles from "./style.scss"
import Modal from 'jd-library/Modal';
import Button from 'jd-library/Button';
import withPortal from 'jd-library/withPortal';
import historyHandler from 'jd-library/historyHandler';
import Image from "../../../common/product-image/ImageViewUpload";

function MRPCommissionDetail(props) {
  const { initialCommissionModalState = false, onCommissionModalStateChange = () => { }, productData, onCommissionSubmit = () => { }, batch_MRP } = props
  const [CommissionModal, setCommissionModalState] = useState(initialCommissionModalState)
  let imgURL = productData?.imageUrl?.split(',')[0] || ''

  useEffect(() => {
    setCommissionModalState(initialCommissionModalState)
  }, [initialCommissionModalState])

  useEffect(() => {
    onCommissionModalStateChange(CommissionModal)
  }, [CommissionModal])

  const formatDate = (dateObj) => {
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    return `${dateObj.getDate()} ${month[dateObj.getMonth()]} ${dateObj.getFullYear().toString().slice(2)}`
  }


  return (
    <div className={styles["mrp_commission_detail"]}>
      {
        CommissionModal &&

        <Modal
          settings={{
            modalId: 'basic-modal',
            class: styles['commission_content_modal'],
          }}
          onHidden={() => {
            setCommissionModalState(false)
          }}
          backdropStatic
        >
          <div className={styles['show_commission_content']}>
            <Modal.CloseIcon />
            <Modal.Header className={styles['commission_content_header']}>
              <div className={styles['commission_content_title']}>
                Commission Details
              </div>
              <div className={styles['commission_content_short_description']}>
                <div className={styles["product_info"]}>
                  {/* <img src={imgURL} className={styles["product_image"]} /> */}
                  <Image
                    className={styles["product_image"]}
                    showAddImageWithText
                    showCheckBox={false}
                    imageUrlArr={productData?.imageUrlArr}
                    isBrandedProd={true}
                    isGalleryProd={false}
                    pos='bottom'
                    fromListing={true}
                    isTemplate={productData?.isTemplate}
                    imageUrl={imgURL}
                  />

                  <div className={styles["product_name"]}>
                    {productData.productName}
                  </div>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className={styles['commission_content_modal_body']}>
              <div className={styles['commission_content_rows']}>
                {
                  batch_MRP?.length && batch_MRP?.map(cur_batch => {
                    return <div className={styles['commission_detail_row']}>
                      <div className={styles['batch_creation_date']}>
                        Batch Creation Date:&nbsp;
                        <span>
                          {formatDate(new Date(cur_batch["createdon"]))}
                        </span>
                      </div>
                      <div className={styles['tbl']}>
                        <table>
                          <tbody>
                            <tr className={styles['selling_online_price']}>
                              <th>
                                Selling Price :&nbsp;
                              </th>

                              <td>
                                {
                                  cur_batch["selling_price"]?.value ?
                                    <span className={styles['semi-bold']}>₹ {cur_batch["selling_price"]?.value}</span>
                                    : <span className={styles['semi-bold']}>₹ {cur_batch["selling_price"]}</span>
                                }

                              </td>
                            </tr>
                            <tr className={styles['commission']}>
                              <th>
                                Commission :&nbsp;
                              </th>
                              <td>
                                <span className={styles['bold']}>{cur_batch["commission_value"]}%</span> on Selling Price + GST
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  })
                }
              </div>
              <Button
                className={`${styles["commission_content_button"]}`}
                block
                size='lg'
                children='Ok, Got It'
                onClick={() => {
                  setCommissionModalState(false)
                  onCommissionSubmit();
                  historyHandler.closeCurrent();
                  props.onClose ? props.onClose() :
                  historyHandler.closeAll()
                  props?.updateList();
                }}
              />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </div>
        </Modal>
      }

    </div>
  )
}


export default withPortal(MRPCommissionDetail)